import React, { useEffect } from 'react'
import Navbar from '../Navbar'
import { Box } from '@mui/material'
import '../BlockId/blockid.css'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useLocation, Link } from 'react-router-dom';
import Footer from '../Footer';

const getBLockNumber = (id) => {
  return parseInt(id) + 6000000
}
const blockValue = (trans) => {
  return trans.length > 0 ? trans?.reduce((a, b) => Number(a) + Number(b.price), 0).toFixed(5) : 0
}
const getBlockSize = (data) => {
  return JSON.stringify(data).length > 1000
    ? `${JSON.stringify(data).length / 1000} Kb`
    : `${JSON.stringify(data).length} bytes`
}

export default function Block() {
  const location = useLocation()
  const blockIdData = location.state;
  const [formatTime, setFormatTime] = React.useState();

  const TimeFormat = () => {
    const time = new Date(blockIdData?.timestamp).toUTCString();
    setFormatTime(time);
  };

  useEffect(() => {
    TimeFormat();
  }, [blockIdData]);

  if (!blockIdData) {
    return (
      <Box>
        <Navbar />
        <section className="term-detail-page">
          <div className="container">
            <div className="term-detail-empty">▸ NO BLOCK DATA</div>
          </div>
        </section>
        <Footer />
      </Box>
    )
  }

  return (
    <Box>
      <Navbar />
      <section className="term-detail-page">
        <div className="container">

          {/* Header */}
          <div className="term-detail-header">
            <div className="term-detail-crumb">
              <Link to="/">HOME</Link>
              <span>/</span>
              <Link to="/allBlock">BLOCKS</Link>
              <span>/</span>
              <span className="term-detail-crumb-active">#{getBLockNumber(blockIdData.index)}</span>
            </div>
            <div className="term-detail-title-row">
              <h1 className="term-detail-title">▸ BLOCK <span>#{getBLockNumber(blockIdData.index)}</span></h1>
              <span className="term-status">
                <span className="term-dot"></span>FINALIZED
              </span>
            </div>
          </div>

          {/* Summary cards */}
          <div className="term-detail-summary">
            <div className="term-summary-card">
              <div className="term-summary-lbl">BLOCK HEIGHT</div>
              <div className="term-summary-val">{getBLockNumber(blockIdData.index)}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">TRANSACTIONS</div>
              <div className="term-summary-val">{blockIdData.data.length}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">BLOCK VALUE</div>
              <div className="term-summary-val term-summary-green">${blockValue(blockIdData.data)}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">BLOCK SIZE</div>
              <div className="term-summary-val">{getBlockSize(blockIdData.data)}</div>
            </div>
          </div>

          {/* Detail panel */}
          <div className="term-detail-panel">
            <div className="term-detail-panel-head">
              <span className="term-panel-title">▸ BLOCK DETAILS</span>
            </div>

            <div className="term-detail-rows">
              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Height</div>
                <div className="term-detail-val">{getBLockNumber(blockIdData.index)}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">No. of Transactions</div>
                <div className="term-detail-val">{blockIdData.data.length}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Size</div>
                <div className="term-detail-val">{getBlockSize(blockIdData.data)}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Status</div>
                <div className="term-detail-val">
                  <span className="successButton">
                    <i><CheckCircleIcon /></i>
                    Success
                  </span>
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Timestamp</div>
                <div className="term-detail-val">
                  <i><AccessTimeIcon sx={{ fontSize: 14, mr: 0.5 }} /></i>
                  {formatTime}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Origination</div>
                <div className="term-detail-val">{blockIdData.origin}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Address</div>
                <div className="term-detail-val term-addr">{blockIdData?.hash}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Previous Block</div>
                <div className="term-detail-val term-addr">{blockIdData?.previousHash}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Node</div>
                <div className="term-detail-val">{blockIdData?.node}</div>
              </div>

              <div className="term-detail-row term-detail-row-stack">
                <div className="term-detail-lbl">Transactions ({blockIdData.data?.length || 0})</div>
                <div className="term-detail-val">
                  {blockIdData.data && blockIdData.data.length > 0 ? (
                    <div className="term-tx-list">
                      {blockIdData.data.map((trans, i) => (
                        <Link key={i} to={`/tx/${trans.hash}`} className="term-tx-hash-link">
                          <span className="term-tx-bullet">▸</span>
                          {trans.hash}
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <span className="term-detail-empty-inline">— no transactions —</span>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      <Footer />
    </Box>
  )
}